import type { RequestSubmission } from '@vemedia/request-contract'

export interface ContactFormValues {
    fullname: string
    email: string
    message: string
    consent: boolean
}

export const EMPTY_CONTACT_FORM: ContactFormValues = {
    fullname: '',
    email: '',
    message: '',
    consent: false,
}

export function buildContactRequest(values: ContactFormValues, pageUrl: string, website = ''): RequestSubmission {
    return {
        kind: 'contact',
        title: 'Contact request',
        contact: { name: values.fullname, email: values.email },
        source: { pageUrl },
        fields: [{ key: 'message', label: 'Message', value: values.message, format: 'multiline' }],
        website,
    }
}
